export const programsData = [
  {
    image: "../dumbell.svg",
    title: "Strength Training",
    description:
      "In this program, you are trained to improve your strength through many exercises",
  },
  {
    image: "../runing.svg",
    title: "Cardio Training",
    description:
      "In this program, you are trained to do sequential moves in range of 20 until 30 minutes.",
  },
  {
    image: "../flame.svg",
    title: "Fat Burning",
    description:
      "This program is suitable for you who wants to get rid of your fat and lose their weight..",
  },
  {
    image: "../heart.png",
    title: "Health Fitness",
    description:
      "This programs is designed for those who exercises only for their body fitness not body building.",
  },
];
